<template>
  <div>
    <v-row align="center" no-gutters>
      <v-col cols="12" md="6" class="pb-0">
        <v-row justify="center">
          <v-col cols="auto">
            <img
              src="@/assets/login-page-art.svg"
              class="artwork pa-md-0"
              alt=""
            />
          </v-col>
          <!-- <v-col cols="auto" class="d-none d-md-block subtext mx-auto mt-6">
            Join now to gain insights from seasoned traders and contribute your own investing ideas to our dynamic groups.
          </v-col> -->
        </v-row>
      </v-col>
      <v-col cols="12" md="6" class="right__col">
        <login-form />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import LoginForm from "./AuthForms/LoginForm.vue";

export default {
  name: "login",
  components: {
    "login-form": LoginForm,
  },
  data() {
    return {
      login_screen_image: require("@/assets/images/login_screen.png"),
      left_image_big_screen: require("@/assets/images/left_image_big_screen.png"),
    };
  },
  mounted() {
    this.$logEvent("login_page_view");
    if (this.$vuetify.breakpoint.xsOnly) {
      this.$logEvent("mweb_login_page_view");
    }
  },
};
</script>

<style scoped>
.subtext {
  font-weight: 900;
  font-size: 30px;
  line-height: 44px;
  color: #333333;
  max-width: 567px;
}

.row {
  height: 100%;
}

.title__text {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 600;
  font-size: 26px;
  padding: 5px 15px;
  line-height: 46px;
  color: #333333;
}
/* @media all  and (max-width: 600px) { */
.left__image__big__screen {
  display: none;
}

.artwork {
  min-width: 268px;
  max-width: 600px;
  padding-right: 7rem;
  padding-left: 2.75rem;
  padding-top: 2rem;
  width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.main__div {
  /* background: #e8f2ff;*/
  background: #fff;
  min-height: 100%;
  height: 100%;
}
.right__col {
  background-color: #e8f2ff;
  height: 100vh;
}
@media all and (min-width: 1000px) {
  .main__div {
    min-height: 100%;
  }
  .title__text {
    font-family: "Avenir";
    font-style: normal;
    font-weight: 600;
    font-size: 34px;
    padding-left: 62px;
    padding-bottom: 50px;
    padding-top: 40px;
    line-height: 46px;
    color: #333333;
  }
  .left__image__big__screen {
    height: 600px;
    display: initial;
    padding-left: 50px;
    margin-bottom: 0px;
  }

  .right__col {
    background-color: #e8f2ff;
    height: 100%;
  }
}

@media all and (min-width: 1500px) {
  .left__image__big__screen {
    height: 600px !important;
    padding: 0px !important;
    margin: 0px !important;
  }
}

@media only screen and (max-width: 600px) {
  .artwork {
    display: none;
  }
}
</style>
